import { getJson, postForm } from '../../../shared/api/httpClient';

export async function fetchCounterPoints({ userAccessToken, deviceAccessToken }) {
  const jsonResponse = await getJson('GetMarivalCountPoints', {
    UserAccessToken: userAccessToken,
    DeviceAccessToken: deviceAccessToken,
    RegisterType: 'Agent'
  });

  return {
    pointsAvailable: jsonResponse.PointsAvailable,
    pointsPending: jsonResponse.PointsPending
  };
}

export async function fetchRoomTypes(lang) {
  const jsonResponse = await getJson('GetRoomsTypes', { lang });

  if (jsonResponse.data && jsonResponse.data.docs) {
    return jsonResponse.data.docs;
  }

  return jsonResponse.data || [];
}

export async function fetchSuppliers() {
  const jsonResponse = await getJson('GetMarivalSuppliers', {});

  return jsonResponse.data;
}

export function submitBooking(payload) {
  return postForm('MarivalRegisterBooking', payload);
}
